import { useEffect, useState } from "react";
import { Modal, Form, Input, Select, Button, Row, Col, Switch } from "antd";
import { showNotificationTopEnd } from "../../../../../util/utils";
import {
  DASHBOARD_PAY_METHODS,
  GENERAL,
} from "../../../../../constants/AppConstants";

const { Option } = Select;

export default function PayMethodCreateForm(props) {
  const { visible, onClose, initialValues = null, onSubmit } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const isEdit = Boolean(initialValues);

  useEffect(() => {
    if (visible) {
      form.resetFields();
      if (isEdit) {
        form.setFieldsValue(initialValues);
      }
    }
  }, [visible, initialValues, isEdit, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const response = await onSubmit(values);
      if (response?.status === 200) {
        form.resetFields();
        onClose();
        showNotificationTopEnd(
          "success",
          isEdit ? "Método de pago actualizado" : "Método de pago creado"
        );
      } else {
        showNotificationTopEnd("error", "Error al guardar");
      }
    } catch (error) {
      console.log("Errores de validación:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        isEdit
          ? DASHBOARD_PAY_METHODS.ACTIONS.TOOLTIPS.EDIT +
          GENERAL.SPACE +
          DASHBOARD_PAY_METHODS.TITLE_SIMPLE
          : DASHBOARD_PAY_METHODS.ACTIONS.TOOLTIPS.ADD +
          GENERAL.SPACE +
          DASHBOARD_PAY_METHODS.TITLE_SIMPLE
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
    >
      <Form form={form} layout="vertical" initialValues={{ active: true }}>
        <Row>
          <Col className="px-5" xs={24} sm={24} md={12}>
            <Form.Item label="ID" name="payMethodId">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col className="px-5" xs={24} sm={24} md={12}>
            <Form.Item
              label={DASHBOARD_PAY_METHODS.COLUMNS.BANK}
              name="bank"
              rules={[{ required: true, message: "Banco requerido" }]}
            >
              <Select>
                <Option value="BBVA">BBVA</Option>
                <Option value="Banamex">Banamex</Option>
                <Option value="Bancoazteca">Banco Azteca</Option>
                <Option value="Bancoppel">Bancoppel</Option>
                <Option value="Banorte">Banorte</Option>
                <Option value="Santander">Santander</Option>
                <Option value="Scotiabank">Scotiabank</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col className="px-5" xs={24} sm={24} md={12}>
            <Form.Item
              label={DASHBOARD_PAY_METHODS.COLUMNS.NAME}
              name="owner"
              rules={[{ required: true, message: "Nombre requerido" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col className="px-5" xs={24} sm={24} md={12}>
            <Form.Item
              label={DASHBOARD_PAY_METHODS.COLUMNS.CARD_NUMBER}
              name="cardNumber"
              rules={[{ required: true, message: "Número requerido" }]}
            >
              <Input maxLength={16} />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col className="px-5" xs={24} sm={24} md={12}>
            <Form.Item
              label={DASHBOARD_PAY_METHODS.COLUMNS.CARD_TYPE}
              name="cardType"
              rules={[{ required: true, message: "Tipo requerido" }]}
            >
              <Select>
                <Option value="Debito">Debito</Option>
                <Option value="Credito">Credito</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col className="px-5" xs={24} sm={24} md={12}>
            <Form.Item
              label={DASHBOARD_PAY_METHODS.COLUMNS.STATUS}
              valuePropName="checked"
              name="active"
              rules={[{ required: true }]}
            >
              <Switch
                checkedChildren="Activo"
                unCheckedChildren="Inactivo"
                defaultChecked
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" onClick={handleSubmit} loading={loading} block>
            {isEdit
              ? DASHBOARD_PAY_METHODS.ACTIONS.TOOLTIPS.UPDATE
              : DASHBOARD_PAY_METHODS.ACTIONS.TOOLTIPS.SAVE}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
